module.exports = __webpack_public_path__ + "img/8.d282555f.png";